export default {
    name: 'Active',
    // methods: {
    //   onScroll() {
    //     let scrollY = window.scrollY
    //     let offsetTop = this.$refs.self.offsetTop
    //     console.log(this.index, '--', 'scrollY:', scrollY, ',offset:', offsetTop);
    //     // 滚动条在当前元素上方100像素内，认为激活
    //     if (scrollY > offsetTop - 100 && scrollY < offsetTop) {
    //       this.$emit('active', this.index);
    //     }
    //     if (scrollY < offsetTop - 100 && scrollY > offsetTop - 200) {
    //       this.$emit('inactive', this.index);
    //     }
    //   }
    // },
    mounted() {
      // 把当前元素的头部位置上报
      // this.$emit('ready', this.index, this.$refs.self.offsetTop);
      // window.addEventListener('scroll', this.onScroll)
    },
    methods: {
      emitReady() {
        this.$emit('ready', this.index, this.$refs.self.offsetTop);
      }
    }
    // destroyed() {
    //   console.log('destroyed')
    //   window.removeEventListener('scroll', this.onScroll)
    // }
  }
  